module.exports = __webpack_public_path__ + "static/media/admission-banner-blue.07898313.jpg";